import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import OrganizerCard from '../../../components/purchase-dashboard/group-summary/organizer-card';
import CommitDeadline from '../../../components/purchase-dashboard/group-summary/commit-deadline';
import ContributionsProgress from '../../../components/purchase-dashboard/group-summary/contributions-progress';
import ContributorsProgress from '../../../components/purchase-dashboard/group-summary/contributors-progress';
import SummaryShareCommitted from './summary-share-committed.container';
import SummaryShareShort from './summary-share-short.container';
import SummaryShareContribute from './summary-share-contribute.container';
import SummaryShareCharged from './summary-share-charged.container';
import SummaryShareFailed from './summary-share-failed.container';
import DisabledOverlay from '../../../components/purchase-dashboard/disabled-overlay';

import Purchase from '../../../lib/purchase';
import Payment from '../../../lib/payment';
import Membership from '../../../lib/membership';
import {
  getOrganizerMembership,
  getCurrentUserMembership,
} from '../../../selectors/purchase-selector';
import '../../../css/group-summary.css';

class GroupSummary extends Component {
  get canContribute() {
    const { currentPayment } = this.props;
    return currentPayment && Payment.isActive(currentPayment.status);
  }

  get hasPaymentIssues() {
    const { currentUserMembership } = this.props;
    return currentUserMembership && currentUserMembership.failed;
  }

  get hasPreviousCharge() {
    const { currentUserMembership } = this.props;
    return currentUserMembership && currentUserMembership.collectedAmount.amountCents > 0;
  }

  get shouldRenderShortShare() {
    const { committed, short } = this.props;
    return committed && short;
  }

  showCommitDeadline() {
    if (this.props.isCompleted) {
      return true;
    }

    if (this.props.isActive && !!this.props.commitDeadline) {
      return true;
    }

    return false;
  }

  showingContributionsProgress() {
    const { splitType } = this.props;
    return Purchase.isSpecifiedPerPerson(splitType);
  }

  showingContributorsProgress() {
    const { productOrGroupMinSlots } = this.props;
    return productOrGroupMinSlots !== 1;
  }

  renderOrganizer() {
    const { organizer, currentUserMembership } = this.props;
    const isOrganizerLoggedIn = currentUserMembership && currentUserMembership.role === 'organizer';

    return (
      <OrganizerCard
        organizer={organizer}
        isOrganizerLoggedIn={isOrganizerLoggedIn}
      />
    );
  }

  renderContributions() {
    if (!this.showingContributionsProgress()) return null;

    return (
      <ContributionsProgress
        committedAmount={this.props.committedAmount}
        totalAmount={this.props.totalAmount}
        purchase={this.props.purchase}
      />
    );
  }

  renderContributors() {
    if (!this.showingContributorsProgress()) return null;

    return (
      <ContributorsProgress
        maxSlots={this.props.productOrGroupMaxSlots}
        minSlots={this.props.productOrGroupMinSlots}
        committedSlots={this.props.committedSlots}
        isCompleted={this.props.isCompleted}
        purchase={this.props.purchase}
      />
    );
  }

  renderDisableOverlay() {
    if (this.props.disable) return <DisabledOverlay />;
  }

  renderTime() {
    if (!this.showCommitDeadline()) return null;

    return (
      <CommitDeadline
        deadline={this.props.commitDeadline}
        lastPaymentSubmittedAt={this.props.lastPaymentSubmittedAt}
        isCompleted={this.props.isCompleted}
        isActive={this.props.isActive}
      />
    );
  }

  renderMemberShareSummary() {
    const {currentUserMembership, waitingToComplete, committed } = this.props;

    if (!currentUserMembership && waitingToComplete) return null;

    if (this.hasPaymentIssues) return <SummaryShareFailed />;
    if (this.hasPreviousCharge) return <SummaryShareCharged />;
    if (this.shouldRenderShortShare) return <SummaryShareShort />;
    if (committed) return <SummaryShareCommitted />;
    if (this.canContribute) return <SummaryShareContribute />;

    return null;
  }

  render() {
    return (
      <div className="group-summary card">
        <div className="card-block">
          {this.renderOrganizer()}
          <div>
            <hr className="mb-4" />
            {this.renderContributions()}
            {this.renderContributors()}
            {this.renderTime()}
          </div>
        </div>
        {this.renderMemberShareSummary()}
        {this.renderDisableOverlay()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = state.purchases.byId[state.purchases.current];
  const organizerMembership = getOrganizerMembership(state);
  const currentUserMembership = getCurrentUserMembership(state);

  const committed = currentUserMembership && Membership.isCommitted(currentUserMembership.status);
  const short = currentUserMembership && currentUserMembership.short;

  const lastPayment = Purchase.getCurrentOrLastPayment(purchase);

  return {
    isCompleted: Purchase.isCompleted(purchase),
    lastPaymentSubmittedAt: get(lastPayment, 'submittedAt'),
    organizer: organizerMembership.user,
    splitType: purchase.group.splitType,
    committedAmount: purchase.committedSharesAmount,
    totalAmount: purchase.currentTotalCostAmount,
    productOrGroupMinSlots: purchase.productOrGroupMinSlots,
    productOrGroupMaxSlots: purchase.productOrGroupMaxSlots,
    committedSlots: purchase.committedSlots,
    currentPayment: purchase.currentPayment,
    committed,
    short,
    currentUserMembership,
    commitDeadline: purchase.group.commitDeadline,
    disable: Purchase.isCanceled(purchase.status),
    isActive: Purchase.isActive(purchase.status),
    waitingToComplete: Purchase.isWaitingForMerchantToComplete(purchase),
    purchase,
  };
};

export default connect(mapStateToProps)(GroupSummary);




// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/group-summary/index.js